import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const TermsInline = ({ locale, title, classNames}) => {
  const src = "/terms/termos-e-condicoes-clientes.html";
  return (
    <div class="iframe__container"> 
        <iframe
            class={`iframe__responsive${classNames ? ` ${classNames}` : ''}`}
            src={src}
            title={`${title ? `${title}` : ''}`}
        />
    </div>
  );
};

TermsInline.propTypes = {
  classNames: PropTypes.string,
  locale: PropTypes.string,
  title: PropTypes.string
};

TermsInline.defaultProps = {
  classNames: null,
  locale: null,
  title: null
};

export default TermsInline;
